import {useCallback, useEffect, useState} from 'react';
import dayjs from 'dayjs';
import {
  getHiddenPopupState,
  setHiddenPopupState,
} from '@/utils/main/my-plus/bottomBanner';
import FloatingBannerContent from './FloatingBannerContent';
import {FloatingBannerProps} from '../type';

const COOKIE_KEY_HIDE_BANNER = 'chk_banner';

const FloatingBanner = ({data, sendClickLog}: FloatingBannerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const days = dayjs(data.endDate).diff(dayjs(), 'day');

  const handleLinkClick = () => {
    sendClickLog('landing_page');
  };

  const closeFloatingBanner = useCallback(() => {
    setIsOpen(false);
    const soopiRoot = document.querySelector('#soopi_wrap') as HTMLElement;
    if (soopiRoot) {
      soopiRoot.style.display = 'block';
    }
  }, [setIsOpen]);

  // 닫기
  const handleClose = () => {
    closeFloatingBanner();
    sendClickLog('close');
  };

  // 다시 보지 않기
  const handleHide = () => {
    closeFloatingBanner();
    setHiddenPopupState(COOKIE_KEY_HIDE_BANNER, data.bannerName, days, true);
    sendClickLog('do_not_show');
  };

  useEffect(() => {
    const now = new Date();
    if (
      !(
        (!data.startDate || new Date(data.startDate) <= now) &&
        (!data.endDate || now <= new Date(data.endDate))
      )
    ) {
      // 노출 기한 벗어남
      return;
    }

    const showBanner = () => {
      const hiddenStates = getHiddenPopupState(COOKIE_KEY_HIDE_BANNER);
      if (hiddenStates[data.bannerName] === 'y') {
        // N일간 다시보지 않기 설정되어있음
        return;
      }

      const soopiRoot = document.querySelector('#soopi_wrap') as HTMLElement;
      if (soopiRoot) {
        soopiRoot.style.display = 'none';
      }
      setIsOpen(true);
    };

    showBanner();
  }, [data, days]);

  if (!isOpen) {
    return null;
  }

  return (
    <FloatingBannerContent
      {...data}
      handleLinkClick={handleLinkClick}
      handleClose={handleClose}
      handleHide={handleHide}
    />
  );
};

export default FloatingBanner;
